import { buildSvgPath } from "@/scripts/common/svg-path";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./scrolling-panels.css";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-scrollingpanels").forEach((el) => {
    const prevEl = el.previousElementSibling;

    const mm = gsap.matchMedia();
    let resizeObserver;

    mm.add("(min-width: 768px)", () => {
      const panelWrapper = el.querySelector(".panel-wrapper");
      const panelContent = el.querySelector(".panel-content");
      const panelMedia = el.querySelector(".panel-media");
      const panelCount = panelMedia.children.length;
      const panelPagination = el.querySelector(".panel-pagination");
      let panelHeight = el.getBoundingClientRect().height;
      let currentPanel = 0;

      gsap.set(panelMedia, { y: (panelCount - 1) * -panelHeight });

      const handleResize = () => {
        const temp = document.createElement("div");
        temp.style.cssText = `
          position: absolute;
          visibility: hidden;
          height: var(--panel-height);
          width: 1px;
        `;
        el.appendChild(temp);

        const newPanelHeight = temp.getBoundingClientRect().height;
        el.removeChild(temp);

        panelHeight = newPanelHeight;

        ScrollTrigger.refresh();

        gsap.set(panelMedia, {
          y: (panelCount - 1 - currentPanel) * -panelHeight,
        });
        gsap.set(panelContent, {
          y: -currentPanel * panelHeight,
        });
      };

      if (!resizeObserver) {
        resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(el);
      }

      ScrollTrigger.create({
        trigger: panelWrapper,
        anticipatePin: true,
        pin: true,
        start: () => {
          const headerOffset = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue("--site-header-height"),
          );
          const elementOffset = parseInt(getComputedStyle(el.querySelector(".section-panel")).marginTop);
          const offset = headerOffset;

          return `top-=${elementOffset} ${offset}px`;
        },
        end: () => {
          return `+=${panelHeight * panelCount}`;
        },
        markers: false,
        onUpdate: (self) => {
          const progress = self.progress;
          const targetPanel = Math.floor(progress * panelCount);
          const panelProgress = (progress * panelCount) % 1;
          const currentPanelElement = panelContent.children[currentPanel];
          const scrollIndicator = currentPanelElement?.querySelector(".panel-scroll-progress");

          if (scrollIndicator) {
            gsap.set(scrollIndicator, {
              height: `${panelProgress * 100}%`,
            });
          }

          if (targetPanel !== currentPanel && targetPanel < panelCount) {
            currentPanel = targetPanel;

            gsap.to(panelMedia, {
              y: (panelCount - 1 - currentPanel) * -panelHeight,
              duration: 0.3,
              ease: "power2.out",
            });

            gsap.to(panelContent, {
              y: -currentPanel * panelHeight,
              duration: 0.3,
              ease: "power2.out",
            });

            if (panelPagination) {
              panelPagination.querySelectorAll(".is-active").forEach((x) => x.classList.remove("is-active"));
              panelPagination
                .querySelector("ul")
                .children[currentPanel].querySelector("button")
                .classList.add("is-active");
            }
          }
        },
      });

      const handlePaginationClick = (e) => {
        const button = e.target.closest("button");
        const index = parseInt(button.dataset.pos) - 1;

        panelPagination.querySelectorAll(".is-active").forEach((x) => x.classList.remove("is-active"));
        button.classList.add("is-active");

        currentPanel = index;

        gsap.to(panelMedia, {
          y: (panelCount - 1 - currentPanel) * -panelHeight,
          duration: 0.3,
          ease: "power2.out",
        });

        gsap.to(panelContent, {
          y: -currentPanel * panelHeight,
          duration: 0.3,
          ease: "power2.out",
        });
      };

      if (panelPagination) {
        panelPagination.querySelectorAll("button").forEach((button) => {
          button.removeEventListener("click", handlePaginationClick);
          button.addEventListener("click", handlePaginationClick);
        });
      }
    });

    if (prevEl.classList.contains("element-largecontentmedia")) {
      const pathContainer = document.body;

      const getPathPoints = () => {
        const elementTitle = el.querySelector(".element-title");
        const elementTitleRect = elementTitle.getBoundingClientRect();
        const prevElTitle = prevEl.querySelector(".element-title");
        const prevElTitleRect = prevElTitle.getBoundingClientRect();
        const additionalLeftX = window.matchMedia("(min-width: 1024px)").matches ? 48 : 0;

        const points = [];

        if (!window.matchMedia("(min-width: 768px)").matches) {
          return points;
        }

        points.push({ x: prevElTitleRect.x + additionalLeftX, y: prevElTitleRect.y + prevElTitleRect.height });
        points.push({
          x: prevElTitleRect.x + additionalLeftX,
          y: elementTitleRect.y + elementTitleRect.height / 2,
        });
        points.push({
          x: elementTitleRect.x - 24,
          y: elementTitleRect.y + elementTitleRect.height / 2,
        });

        return points;
      };

      const handleSvgPath = () => {
        const pathPoints = getPathPoints();
        const cornerRadius = window.matchMedia("(min-width: 1280px) and (max-width: 1700px)").matches ? 20 : 70;

        buildSvgPath(pathContainer, pathPoints, { gradientId: "page-line-gradient-faded", cornerRadius });
      };

      const resizeObserver = new ResizeObserver(() => requestAnimationFrame(handleSvgPath));
      resizeObserver.observe(document.body);
    }
  });
});
